export const CORP_ACCOUNT_NAME_CHAR_LIMIT = 20;
export const EVENT_NAME_CHAR_LIMIT = 50;
export const POINTS_GIVEN_FOR_REVIEW = 100;
